import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'GST on Expenses' },
    { value: 2, label: 'No GST' },
    { value: 3, label: 'Zero Rated' },
    { value: 4, label: 'GST on Income' },
    { value: 5, label: 'GST on Imports' },
  ],
});
